// extracted by mini-css-extract-plugin
module.exports = {"container":"History_container__2s43n","headerTextGroup":"History_headerTextGroup__3xXla","subtitle":"History_subtitle__34nuX","unused":"History_unused__2ntBX"};